// extracted by mini-css-extract-plugin
export default {"seoBlockAction":"c-a_fE"};